/* Featured collection set to "Newest in the store": the grid arrives with
   placeholders and is filled with the products most recently published,
   always those, in that order. The store sorts collections only by when
   products were created, so the catalogue's handles and publication times
   come from templates/collection.tbc-newest-index.liquid (250 to a page),
   are sorted here, and the newest cards come one by one from
   templates/product.tbc-card.liquid.
   The page's other collection grids give way instead: a card of theirs the
   newest already show is swapped for the next product of their own
   collection that is not on the page yet (each grid's <template
   data-tbc-spares>, sections/section-collection.liquid). If the requests
   fail the section steps aside rather than showing placeholders. */

(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      return response.ok ? response.json() : Promise.reject();
    });
  }

  function indexPage(base, page) {
    return getJSON(base + (base.indexOf('?') === -1 ? '?' : '&') + 'page=' + page);
  }

  /* Handles of the most recently published products, newest first. */
  function newestHandles(base, limit) {
    return indexPage(base, 1).then(function (first) {
      var rest = [];
      for (var page = 2; page <= (first.pages || 1); page += 1) rest.push(indexPage(base, page));
      return Promise.all(rest).then(function (pages) {
        var items = [first].concat(pages).reduce(function (all, page) { return all.concat(page.items || []); }, []);
        items.sort(function (a, b) { return b.p - a.p; });
        return items.slice(0, limit).map(function (item) { return item.h; });
      });
    });
  }

  function card(handle) {
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=tbc-card', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        return box.querySelector('.grid-item');
      })
      .catch(function () { return null; });
  }
  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  /* The cards' entrance animation already ran for the page; these arrive late. */
  function settled(card) {
    if (card.hasAttribute('data-aos')) card.classList.add('aos-animate');
    card.querySelectorAll('[data-aos]').forEach(function (node) { node.classList.add('aos-animate'); });
    return card;
  }

  function giveWay(newest) {
    var onPage = {};
    document.querySelectorAll('[data-grid-item]').forEach(function (card) { onPage[handleOf(card)] = true; });

    document.querySelectorAll('template[data-tbc-spares]').forEach(function (template) {
      var grid = template.previousElementSibling;
      if (!grid) return;
      var spares = Array.prototype.slice.call(template.content.children).filter(function (node) {
        return node.matches('[data-grid-item]');
      });
      Array.prototype.forEach.call(grid.children, function (card) {
        if (!card.matches('[data-grid-item]') || !newest[handleOf(card)]) return;
        var spare = null;
        while (spares.length && !spare) {
          var next = spares.shift();
          if (!onPage[handleOf(next)]) spare = next;
        }
        if (!spare) return;
        onPage[handleOf(spare)] = true;
        grid.replaceChild(settled(document.importNode(spare, true)), card);
      });
    });
  }

  function fill(grid) {
    if (grid.hasAttribute('data-tbc-newest-done')) return;
    grid.setAttribute('data-tbc-newest-done', '');
    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 8;

    newestHandles(grid.getAttribute('data-tbc-newest'), limit)
      .then(function (handles) { return Promise.all(handles.map(card)); })
      .then(function (cards) {
        var items = cards.filter(Boolean);
        if (!items.length) throw new Error('empty');

        var newest = {};
        items.forEach(function (item) {
          newest[handleOf(item)] = true;
          settled(item);
        });
        grid.replaceChildren.apply(grid, items);
        grid.removeAttribute('aria-busy');
        giveWay(newest);
      })
      .catch(function () {
        var section = grid.closest('.shopify-section');
        if (section) section.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('[data-tbc-newest]').forEach(fill);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
